import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { ApiResponse } from '@Types/Api';
import type { Query } from '@Types/Base';

interface Params {
  lang: string;
  country: string;
}

async function getUITranslation(params: Params, request: Query) {
  const url = '/localizer/get-ui';
  const res = await Api.queryProxi<ApiResponse<any>>(
    url,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
    request,
  );

  if (!res.ok) throw new BackendError(url, res);

  return res.data;
}

export default getUITranslation;
